import styled from 'styled-components'
import { font, colors, spacing, ChevronIcon } from '@chegg-ui/theme'
import { fanta, SecondaryButton } from '@chegg/fanta'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { TimesNewRomanStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Container = styled.div`
  text-align: center;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.px16};

  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    flex-direction: column;
  }
`

export const LeftSpacer = styled.div`
  width: 112px;
`

export const DropdownContainer = styled.div``

export const Header = styled.h2`
  ${TimesNewRomanStack}
  margin-top: 0px;
  margin-bottom: 0px;
  font-size: ${font.size.px16};
`

export const SortTrigger = styled(SecondaryButton)`
  color: ${({ theme }) => theme.Colors.forFonts.fColor06};
  padding-right: ${spacing.px8};
  cursor: pointer;
`

export const Chevron = styled(ChevronIcon)`
  fill: ${colors.dark};
  height: ${fanta.font.size.md};
  width: ${fanta.font.size.md};
  margin-left: ${spacing.px4};
`
